import React, { createContext, FunctionComponent, MutableRefObject, useEffect, useRef } from 'react'
import styled from 'styled-components'


const Outer = styled.div`
  padding-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;
  width: 100%;
  max-width: 100vw;
  & + & {
    margin-top: 6rem;
  }
`

type SectionProps = {
  id?: string,
  style?: React.CSSProperties
}
export const Section: FunctionComponent<SectionProps> = ({children, id, style}) => {
  return <Outer id={id} style={style}>
      {children}
  </Outer>
}